module.exports = __webpack_public_path__ + "static/media/bg_3.0afbd3e3.png";